export default {
  sale: "sales/{id}/subscription-sale",
  saleContract: "sales/{id}/contracts/",
  sendConfirmationEmail: "sales/{id}/send-confirmation-email/",
}
